import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginProviderAppContainerModel} from '../../../../../models/aggregates/app-login';

@Injectable({providedIn: 'root'})
export class AppLoginProviderAppBackofficeEpService extends BaseApiTemplateService<AppLoginProviderAppContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-login-provider/app-login-provider-apps/backoffice-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-login-provider/app-login-provider-apps/backoffice-ep';
    this.httpClient = http;
  }

}
